//
import { Service } from '@/services/api2'
import SlSaleInvoiceModel from '@/models/Sale/SlSaleInvoice'

/**
 * 
 */
export default class SlSaleInvoiceService extends Service {

  /**
   * The api model of service
   * @returns {Object} api model
   */
  model() {
    return SlSaleInvoiceModel
  }

  /**
   * Return a list service representation
   * @returns {Object} api model
   */
  static toList() {
    return new this()
      .model()
      .setAppends([
      ])
      .setIncludes([
        'sl_customer',
				'sl_customer_branch_offices',
      ])
  }
}